import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Layout from "./Layout";
import SEO from "./SEO";

/**
 * Placeholder page for sections that are announced in the nav but not yet built.
 * Keeps the site's premium dark aesthetic; clearly labelled "under construction"
 * with a way to reach us in the meantime.
 */
const UnderConstruction = ({ eyebrow, seoTitle, seoDescription }) => (
  <Layout>
    <SEO title={seoTitle} description={seoDescription} />
    <section
      style={{
        minHeight: "calc(100vh - 88px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "clamp(60px,10vh,120px) clamp(24px,6vw,80px)",
        position: "relative",
        overflow: "hidden",
        background: [
          "radial-gradient(ellipse 80% 60% at 50% 26%, rgba(103,232,249,0.10) 0%, transparent 58%)",
          "linear-gradient(180deg, #03101C 0%, #051C2C 100%)",
        ].join(", "),
      }}
    >
      {/* Fine technical grid, echoing the research/outlook pages */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          backgroundImage: [
            "linear-gradient(rgba(103,232,249,0.025) 1px, transparent 1px)",
            "linear-gradient(90deg, rgba(103,232,249,0.025) 1px, transparent 1px)",
          ].join(", "),
          backgroundSize: "76px 76px",
          maskImage: "radial-gradient(ellipse 70% 70% at 50% 40%, black 30%, transparent 75%)",
          WebkitMaskImage: "radial-gradient(ellipse 70% 70% at 50% 40%, black 30%, transparent 75%)",
        }}
      />

      <div style={{ position: "relative", zIndex: 1, textAlign: "center", maxWidth: 640 }}>
        <div
          style={{
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 12,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: "#67E8F9",
            fontWeight: 500,
            marginBottom: 22,
          }}
        >
          {eyebrow}
        </div>
        <h1
          style={{
            fontFamily: "Fraunces, serif",
            fontSize: "clamp(40px,6vw,76px)",
            fontWeight: 400,
            color: "#F4F1EB",
            lineHeight: 1.04,
            letterSpacing: "-0.02em",
            margin: 0,
          }}
        >
          Under construction.
        </h1>
        <p
          style={{
            marginTop: "clamp(18px,3vh,28px)",
            marginLeft: "auto",
            marginRight: "auto",
            maxWidth: 480,
            color: "rgba(244,241,235,0.6)",
            fontSize: 17,
            lineHeight: 1.8,
          }}
        >
          We&apos;re putting this together. Check back soon. In the meantime,
          we&apos;re glad to answer anything directly.
        </p>
        <div
          style={{
            marginTop: "clamp(26px,4vh,40px)",
            display: "flex",
            gap: 14,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Link
            to="/about#inquiry"
            className="btn-primary"
            style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
          >
            Speak with us <ArrowRight size={14} />
          </Link>
          <Link to="/" className="btn-ghost">
            Back to home
          </Link>
        </div>
      </div>
    </section>
  </Layout>
);

export default UnderConstruction;
